import React from 'react';
import PropTypes from 'prop-types';

function Edit(props) {
  return (
    <svg width={props.size} height={props.size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.75 17.896h13.146V9.428h1.5v9.968H.25V3.25h10.14v1.5H1.75v13.146zm4.718-7.368l1.064-1.056 2.31 2.328-1.064 1.057-2.31-2.33zm1.81 3.88l-3.703.77c-.338.07-.637-.233-.564-.57l.798-3.696 10.7-10.62c.394-.392 1.034-.386 1.417 0l2.066 2.08c.39.39.386 1.023-.01 1.417L8.278 14.41zm-.74-1.377L17.57 3.073l-1.358-1.368-10.034 9.96-.372 1.726 1.73-.36z" fillRule="nonzero" fill="currentColor" />
    </svg>
  );
}

Edit.defaultProps = {
  size: 20,
};

Edit.propTypes = {
  size: PropTypes.number,
};

export default Edit;
